import script from "./Create_Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Create_Edit.vue?vue&type=script&setup=true&lang=js"

import "./Create_Edit.vue?vue&type=style&index=0&id=8c659166&lang=css"

const __exports__ = script;

export default __exports__